<template>
  <div class="container scene">
    <PageHeader
      :height="1160"
      type=""
      image="//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/07/bann.png"
    />

    <el-row class="items" type="flex">
      <el-col class="item" :span="8" v-for="(item, idx) in 20" :key="'x' + idx">
        <div class="item-thumb" @click="goSingle(idx)">
          <el-image
            class="item-thumb__url"
            src="//leadexv2.weappdev.cn/wp-content/uploads/sites/77/2022/07/bch.png"
            mode="cover"
          ></el-image>
        </div>
        <div class="item-name">MDS-WS04-FB</div>
      </el-col>
    </el-row>

    <!--  -->
    <page-footer />
  </div>
</template>
<style lang="scss" scoped>
.items {
  padding-top: 120px;
  background-color: #fff;
  flex-wrap: wrap;
  padding-left: 160px;
  padding-right: 160px;

  .item {
    margin-bottom: 130px;
    // background-color: #ddd;
    cursor: pointer;
    text-align: center;
    &-thumb__url {
      width: 100%;
      max-width: 400px;
    }

    &-name {
      margin-top: 35px;
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      text-align: center;
      color: #3f3f3f;
    }
  }
}
</style>

<script>
import PageFooter from "../components/PageFooter.vue";
import PageHeader from "../components/PageHeaderV2.vue";
import PageNavbar from "../components/PageNavbar.vue";
import Filters from "../components/Filters.vue";
import AlbumList from "../components/AlbumList.vue";
import Api from "../utils/api";
export default {
  name: "Module",
  components: {
    PageFooter,

    PageNavbar,
    PageHeader,
    Filters,
    AlbumList,
  },
  methods: {
    goSingle(idx) {
      this.$router.push({ name: "Single" });
    },
    queryList(args) {
      Api.getAlbumList(args).then((res) => {
        let items = this.items;
        this.items = [...items, ...res.items];
      });
    },
  },
  created() {
    this.queryList({ pg: 1 });
  },
  data() {
    return {
      showFilter: false,
      brand: "",
      items: [],
    };
  },
};
</script>
